import React from "react";
import { Checkbox, Stack, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";

import { getFieldLabel } from "./helper";

const WorkOrderDepartment = ({ isSelected, label, sectionKey, children }) => {
  const { formState } = useFormContext();
  const { errors } = formState;
  const routeErrors = errors[sectionKey];
  const hasError = isSelected && routeErrors;
  const errorCount = Object.keys(routeErrors || {})?.length || 0;
  const sectionLabel = getFieldLabel(label);

  return (
    <Stack>
      <Stack
        direction="row"
        width="100%"
        padding="8px 12px"
        borderBottom="1px solid"
        borderTop="1px solid"
        borderColor="hubColors.greyLight"
        justifyContent="space-between"
        alignItems="center"
      >
        <Stack direction="row" gap="8px">
          <Checkbox checked={isSelected} sx={{ padding: 0, width: 16 }} />
          <Typography variant="caption">{sectionLabel}</Typography>
        </Stack>
        <Typography>
          {hasError ? `Missing Fields: ${errorCount}` : ""}
        </Typography>
      </Stack>
      {isSelected ? children : <></>}
    </Stack>
  );
};

export default WorkOrderDepartment;
